<script setup lang="ts">
const {isSelected, item} = defineProps(['isSelected'])
const emits = defineEmits(['select'])

function activeClass(isSelected) {
  return isSelected
      ? 'before:bg-primary before:mt-1 before:shadow-primary opacity-100 border-primary/60 border-2'
      : 'opacity-80'
}

function activeShadow(isSelected) {
  return isSelected
      ? 'before:bg-primary/60 before:mt-1 before:shadow-primary '
      : ''
}

</script>

<template>
  <div
      class="cursor-pointer before:hidden xl:before:block intro-y relative before:content-[''] before:bg-white/60  before:w-[90%] before:h-full before:absolute before:rounded-md before:mx-auto before:inset-x-0 before:dark:bg-darkmode-400/70"
      @click="emits('select')"
      :class="activeShadow(isSelected)"
  >
    <div class="p-2 box"
         :class="activeClass(isSelected)"
    >
      <div class=" relative">
        <div class=" ">
          <div class="p-2">
            <h2 class="font-medium truncate">
              <slot></slot>
            </h2>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>

</style>